import {Observable, ReplaySubject} from 'rxjs';

export function fileToBase64(file: File): Observable<string> {
  const result = new ReplaySubject<string>(1);
  const reader = new FileReader();
  reader.readAsBinaryString(file);
  reader.onload = (event) => result.next(btoa(event.target.result.toString()));
  return result;
}
